import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import MainPage from "src/components/Page/MainPage";
import { onSuccessClickFormBasicForm } from "src/helpers/onSuccess";
import { useAppDispatch } from "src/store";
import {
  deleteUygunaKiralaLocationSaga,
  getUygunaKiralaLocationDetailsSaga,
  getUygunaKiralaLocationListSaga,
} from "src/store/uygunakirala-locations/saga";
import {
  UygunaKiralaLocationDetailDto,
  UygunaKiralaLocationDto,
} from "src/store/uygunakirala-locations/type";
import UygunaKiralaLocationCreateForm from "./create";
import UygunaKiralaLocationEditForm from "./edit";
const UygunaKiralaLocationPage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [data, setData] = useState<UygunaKiralaLocationDto[]>([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selected, setSelected] = useState<UygunaKiralaLocationDetailDto>();
  const columns = [
    {
      text: t("UygunaKiralaLocation.Name"),
      dataField: "Name",
    },
  ];

  return (
    <React.Fragment>
      <MainPage
        title={t("UygunaKiralaLocation.PageTitle")}
        metaTag={t("UygunaKiralaLocation.MetaTag")}
        gridProps={{
          addTitle: t("UygunaKiralaLocation.AddButton").toString(),
          listData: data,
          columns: columns,
          setDataList: setData,
          action: getUygunaKiralaLocationListSaga,
          onCreateClick: () => setShowCreate(true),
          editButton: {
            onClick: (id, data) => {
              dispatch(
                getUygunaKiralaLocationDetailsSaga({
                  payload: {
                    onSuccess: (message, payload, response) => {
                      let currenctObject = payload;
                      currenctObject.Translates = response.Translates;
                      setSelected(currenctObject);
                      return setShowEdit(true);
                    },
                    onError: () => {},
                  },
                  id: id,
                })
              );
            },
          },
          deleteButton: {
            text: (id, data: UygunaKiralaLocationDto) =>
              t("UygunaKiralaLocation.DeleteQA", {
                name: data.Name,
              }),
            action: deleteUygunaKiralaLocationSaga,
            onClick: (id, data) => setShowEdit(data),
          },
        }}
      />
      <UygunaKiralaLocationCreateForm
        open={showCreate}
        onHide={() => setShowCreate(false)}
        onSuccessClick={(m) =>
          onSuccessClickFormBasicForm({
            dispatch: dispatch,
            message: m,
            action: getUygunaKiralaLocationListSaga,
            setDataList: setData,
          })
        }
      />
      {selected && (
        <UygunaKiralaLocationEditForm
          data={selected}
          open={showEdit}
          onHide={() => {
            setShowEdit(false);
            return setSelected(undefined);
          }}
          onSuccessClick={(m) =>
            onSuccessClickFormBasicForm({
              dispatch: dispatch,
              message: m,
              action: getUygunaKiralaLocationListSaga,
              setDataList: setData,
            })
          }
        />
      )}
    </React.Fragment>
  );
};

export default UygunaKiralaLocationPage;
